import { createContext, Dispatch, FC, SetStateAction, useContext, useState } from 'react'
import { PropsWithChildren } from 'react'

type FixedDraggableContextProps = {
  reference: HTMLDivElement | null
  setReference: Dispatch<SetStateAction<HTMLDivElement | null>>
  isShow: boolean
  setIsShow: Dispatch<SetStateAction<boolean>>
}

const FixedDraggableContext = createContext<FixedDraggableContextProps>({
  reference: null,
  setReference: () => {},
  isShow: false,
  setIsShow: () => {},
})

const useFixedDraggable = () => useContext(FixedDraggableContext)

const FixedDraggableProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const [reference, setReference] = useState<HTMLDivElement | null>(null)
  const [isShow, setIsShow] = useState<boolean>(false)

  return (
    <FixedDraggableContext.Provider value={{ reference, setReference, isShow, setIsShow }}>
      {children}
    </FixedDraggableContext.Provider>
  )
}

export { FixedDraggableProvider, useFixedDraggable }
